export default __webpack_public_path__ + "42aaa5b43913a18b396b941d308e9cd3.svg";